<!--
 * @Author: jiaoxiaojie jiaoxiaojie666@sina.com
 * @Date: 2023-11-20 10:28:47
 * @LastEditors: jiaoxiaojie jiaoxiaojie666@sina.com
 * @LastEditTime: 2023-11-27 10:55:34
 * @FilePath: \web-qiankun\main\src\views\otherpage.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="Otherpage">
    <bidBox v-if="$route.query.form == 'thr'" />
    <!-- 这里是外部页面 -->
    <!-- $route.path=== '/Approve' -->

    <!-- <iframe
      id="bdIframe"
      :src="url"
      style="width: 100%;height:90vh;"
      frameborder="0"
    /> -->
  </div>
</template>

<script>
import bidBox from '@/views/components/bidBox'
export default {
  name: 'Otherpage',
  components: {
    bidBox
  },
  data () {
    return {
      // url: ""
    }
  },
  created () {
    // 获取页面来源系统
    // if (this.$route.query.form == 'thr') {
    //   // 投标盒子页面
    //   this.url = window.location.protocol +
    //     '//' +
    //     window.location.host +
    //     '/subapp/thr#/bidBoxView'
    // }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.Otherpage {
  min-height: 100vh;
}
</style>
